@if (declaration$ | async; as declaration) {
  <form [formGroup]="form" [attr.autocomplete]="autocomplete() ? 'on' : 'off'">
    @for (
      _page of pages;
      track _page.key;
      let stepIndex = $index;
      let isFirstPage = $first
    ) {
      <div
        [style.display]="_page === page ? null : 'none'"
        attr.data-testid="form_step_{{ stepIndex }}"
        class="page-key--{{ _page.key }}"
      >
        @for (
          fieldset of _page.fieldsets;
          track fieldset.key;
          let isFirstFieldset = $first
        ) {
          <declarative-fieldset
            class="grid"
            [fieldset]="fieldset"
            [form]="form"
            [formGroupName]="fieldset.key"
            attr.data-testid="{{ fieldset.key }}"
          >
            @for (
              field of fieldset.fields;
              track field.key;
              let isFirstField = $first
            ) {
              <declarative-field
                [class]="field.style || 'w-full'"
                [formControlName]="field.key"
                [field]="field"
                [form]="form"
                [fieldset]="fieldset"
                [declaration]="declaration"
                [isCurrentStep]="_page === page"
                attr.data-testid="{{ field.key }}"
                [autofocus]="
                  isFirstPage &&
                  isFirstFieldset &&
                  isFirstField &&
                  canAutofocus()
                "
              />
            }
          </declarative-fieldset>
        }
      </div>
    }
  </form>
}
